import { render, staticRenderFns } from "./crm2.vue?vue&type=template&id=7b5ed55e&scoped=true"
import script from "./crm2.vue?vue&type=script&lang=js"
export * from "./crm2.vue?vue&type=script&lang=js"
import style0 from "./crm2.vue?vue&type=style&index=0&id=7b5ed55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5ed55e",
  null
  
)

export default component.exports